export const environment = {
    production: true,
    apiUrl: '/EDU/api',
    razorpayKey: 'rzp_live_dPwvPZHJKGfv6n',
    recaptchaSiteKey: '6Lf54bUaAAAAAJspHXycV3SjOjTvPNbsv0GWH7YW'
};
